import { Icon } from '@iconify/react';
import { Trans, useTranslation } from 'react-i18next';

export const ParagraphListEmpty = () => {
  const { t } = useTranslation('paragraphs');

  return (
    <div
      className="h-fill-available flex flex-col gap-3 flex-1 items-center justify-center"
      data-testid="empty-paragraph-list"
    >
      <div className="!size-8 border border-border rounded-lg shadow-sm flex items-center justify-center">
        <Icon icon="mingcute:paragraph-line" />
      </div>
      <p className="text-sm font-medium text-foreground">{t('modal.list.empty.title')}</p>
      <p className="text-sm text-foreground-subtle text-center">
        <Trans t={t} i18nKey="modal.list.empty.description" />
      </p>
    </div>
  );
};
